(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_contact-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const contactOption = document.querySelector('.contact__option');
    const selects = document.querySelectorAll('.contact__option select');
    let firstOption,
      secondOption = null;
    window.selectedForm = '';

    contactOption.querySelector('select')?.classList.add('contact__option--1');

    selects?.forEach((select) => {
      select.addEventListener('change', (e) => {
        const selectedOption = e.target.selectedOptions[0];
        select.classList.contains('contact__option--1') ? updateOption1(selectedOption) : updateOption2(selectedOption);
      });
    });

    const updateOption1 = (option) => {
      firstOption = option.value;
      const allContactOptions = document.querySelectorAll('.contact__option');
      allContactOptions.forEach((el) => el.classList.remove('active'));

      hideAllForms();

      const targetToShow = document.getElementById(option.dataset.target);
      targetToShow.classList.add('active');
      targetToShow.querySelector('select').value = '';
    };

    const updateOption2 = (option) => {
      secondOption = option.value;
      updateGlobalSelection();
    };

    const updateGlobalSelection = () => {
      window.selectedForm = `${firstOption.trim()}-${secondOption.trim()}`;
      hideAllForms();

      const targetToShow = [...document.querySelectorAll('[data-form-container]')].find(
        (el) => el.dataset.formContainer === window.selectedForm
      );
      targetToShow?.classList.add('active');
    };

    const hideAllForms = () => {
      const allContactForms = document.querySelectorAll('.contact__form');
      allContactForms.forEach((el) => el.classList.remove('active'));
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMenuKeyboard() {
      const menuItems = document.querySelectorAll(
        'overflow-list .menu-list__list-item, nav.menu-list .menu-list__list-item'
      );
      if (!menuItems.length) return;

      menuItems.forEach((item, itemIndex) => {
        const trigger = item.querySelector(':scope > a.menu-list__link, :scope > button.menu-list__link');
        const submenuEl = item.querySelector('.menu-list__submenu');
        if (!trigger) return;

        const getSubmenuLinks = () =>
          submenuEl ? Array.from(submenuEl.querySelectorAll('a[href], button:not([disabled])')) : [];

        if (submenuEl) {
          getSubmenuLinks().forEach((el) => el.setAttribute('tabindex', '-1'));
        }

        trigger.addEventListener(
          'focusin',
          (e) => {
            // Ne stoppe que si le focus vient du clavier (pas d'un clic)
            if (!item.matches(':focus-within') || e.relatedTarget === null) return;
            e.stopPropagation();
          },
          true
        );

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (submenuEl) {
              e.preventDefault();
              openSubmenu(item, trigger);
              const links = getSubmenuLinks();
              if (links.length) links[0].focus();
            }
          } else if (e.key === 'Escape') {
            closeSubmenu(item, trigger);
          }
        });

        if (submenuEl) {
          submenuEl.addEventListener('keydown', (e) => {
            const links = getSubmenuLinks();
            const focused = document.activeElement;
            const idx = links.indexOf(focused);

            if (e.key === 'Escape') {
              e.preventDefault();
              closeSubmenu(item, trigger);
              trigger.focus();
            } else if (e.key === 'Tab' && !e.shiftKey) {
              e.preventDefault();
              if (idx < links.length - 1) {
                links[idx + 1].focus(); // item suivant dans le sous-menu
              } else {
                closeSubmenu(item, trigger);
                const next = getNextTrigger(itemIndex, menuItems);
                if (next) next.focus();
              }
            } else if (e.key === 'Tab' && e.shiftKey) {
              e.preventDefault();
              if (idx > 0) {
                links[idx - 1].focus(); // item précédent dans le sous-menu
              } else {
                closeSubmenu(item, trigger);
                trigger.focus();
              }
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              if (idx < links.length - 1) links[idx + 1].focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              if (idx > 0) links[idx - 1].focus();
              else {
                closeSubmenu(item, trigger);
                trigger.focus();
              }
            }
          });
        }
      });

      function openSubmenu(item, trigger) {
        trigger.setAttribute('aria-expanded', 'true');
        item.dispatchEvent(new CustomEvent('pointerenter', { bubbles: true }));
      }

      function closeSubmenu(item, trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        item.dispatchEvent(new CustomEvent('pointerleave', { bubbles: true }));
      }

      function getNextTrigger(currentIndex, items) {
        for (let i = currentIndex + 1; i < items.length; i++) {
          const t = items[i].querySelector(':scope > a.menu-list__link, :scope > button.menu-list__link');
          if (t) return t;
        }
        return null;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenuKeyboard);
    } else {
      initMenuKeyboard();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["depict-patched-_product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-product')) {
    customElements.define(
      'card-product',
      class CardProduct extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.BLANK = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

          this.swatches = this.querySelectorAll('.card-product__swatch');
          if (this.swatches.length) this.initSwatches();

          this.hoverPicture = this.querySelector('.data-attributes-trigger--hover');
          if (this.hoverPicture) {
            this.addEventListener('mouseenter', () => this.activatePicture(this.hoverPicture));
            this.addEventListener('mouseleave', () => this.disablePicture(this.hoverPicture));
          }

          this.slider = this.querySelector('.card-product__images--carousel');
          if (this.slider) {
            this.handleSliderImages();
          }

          this.vtoLink = this.querySelector('.vto__link');
          if (this.vtoLink) this.handleVtoLink();
        }

        initSwatches() {
          const swatchesWrapper = this.querySelector('.card-product__swatches');
          const allSwatchesPictures = this.querySelectorAll('.data-attributes-trigger--swatch');
          swatchesWrapper?.addEventListener('mouseleave', () => {
            allSwatchesPictures.forEach((picture) => this.disablePicture(picture));
          });

          this.swatches.forEach((swatch) => {
            swatch.addEventListener('mouseenter', () => {
              allSwatchesPictures.forEach((picture) => this.disablePicture(picture));

              const picture = this.querySelector(`#${swatch.dataset.imageToShow}`);
              this.activatePicture(picture);
            });
          });
        }

        handleSliderImages() {
          const slides = this.slider.querySelectorAll('img');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const picture = entry.target.closest('picture');
                  this.activatePicture(picture);
                }
              });
            },
            { root: this.slider, threshold: 0 }
          );

          slides.forEach((slide) => observer.observe(slide));
        }

        activatePicture(picture) {
          picture.querySelectorAll('source[data-srcset]').forEach((source) => {
            source.srcset = source.dataset.srcset;
            source.removeAttribute('data-srcset');
          });

          const img = picture.querySelector('img[data-src]');
          if (!img) return;

          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          picture.classList.add('active');
        }

        disablePicture(picture) {
          picture.classList.remove('active');

          picture.querySelectorAll('source[srcset]').forEach((source) => {
            source.dataset.srcset = source.srcset;
            source.removeAttribute('srcset');
          });

          const img = picture.querySelector('img');
          if (!img) return;

          if (img.srcset) {
            img.dataset.srcset = img.srcset;
            img.srcset = '';
          }
          if (img.src && !img.src.startsWith('data:')) {
            img.dataset.src = img.src;
          }
          img.src = this.BLANK;
        }

        handleVtoLink() {
          const productId = this.vtoLink.dataset.productId;
          const vtoReference = this.vtoLink.dataset.vtoReference;
          if (!productId || !vtoReference) return;

          const productOptions = JSON.parse(this.querySelector(`#vtoParams${productId}`).textContent);

          const params = {
            apiKey: 'tYzzTYcS8uP7Atn0DBIBfToCz2PTXSlWlJhVDuqj',
            popupIntegration: {
              centeredHorizontal: true,
              centeredVertical: true,
              width: '640px',
              height: '480px',
            },
            carousel: productOptions,
          };

          this.vtoLink.addEventListener('click', () => {
            window.fitmixInstance = FitMix.createWidget(`fitmix-container-${productId}`, params);
            setTimeout(() => {
              window.fitmixInstance.setFrame(vtoReference);
              window.fitmixInstance.startVto('live');
            }, 500);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
